import { useLanguage } from "../../../../../stores/LanguageStore";
import { Anchor, Group, NumberFormatter, Stack, Text } from "@mantine/core";
import { status_list } from "../../../leadsTracking/utils";
import { useConfigStore } from "../../../../../stores/ConfigStore";
import ArgumentsDatabase from "./arguments/ArgumentsDatabase";
import ArgumentsGoogle from "./arguments/ArgumentsGoogle";
import ArgumentsLinkedin from "./arguments/ArgumentsLinkedin";
import ContactsResponse from "./arguments/ContactsResponse";
import { Link } from "react-router-dom";
import ArgumentsContactsSelection from "./arguments/ArgumentsContactsSelection";
import ArgumentsCampaign from "./arguments/ArgumentsCampaign";

export function handleJobItem({ item, fromLists, isProgress, isCompleted }) {
  const lang = useLanguage.getState().language;

  return (
    <Stack mt={"xs"} gap={"xs"}>
      {fromLists && (
        <Group gap={4} mt={"xs"}>
          {lang.contact_lists.jobs.list}
          {Array.isArray(fromLists) ? (
            fromLists.map((list) => (
              <Anchor
                component={Link}
                to={"/contact-lists/" + list.id}
                size="md"
                fw={500}
                key={list.id}
                mr={8}
              >
                {list?.name || ""} #{list.id}
              </Anchor>
            ))
          ) : (
            <Anchor
              component={Link}
              to={"/contact-lists/" + fromLists?.id}
              size="md"
              fw={500}
              key={fromLists?.id}
              mr={8}
            >
              {fromLists?.name || ""} #{fromLists?.id}
            </Anchor>
          )}
        </Group>
      )}

      {item?.arguments?.subject && (
        <Group gap={0} wrap="nowrap" align="start">
          <Text mr={8}>{lang.contact_lists.jobs.completed.subject}:</Text>
          <Text fw={600}>{item?.arguments?.subject}</Text>
        </Group>
      )}
      {item?.arguments?.prompt && (
        <Group gap={0} wrap="nowrap" align="start">
          <Text mr={8}>
            {lang.contact_lists.datafield_content.dialog.prompt}:
          </Text>
          <Text fw={600}>{item?.arguments?.prompt}</Text>
        </Group>
      )}
      {item?.arguments?.language && (
        <Group gap={0} wrap="nowrap">
          <Text mr={8}>{lang.contact_lists.jobs.completed.language}:</Text>
          <Text fw={600}>
            {
              lang.contact_lists.jobs.completed.language_maps[
                item?.arguments?.language
              ]
            }
          </Text>
        </Group>
      )}
      {item?.arguments?.temperature && (
        <Group gap={0} wrap="nowrap">
          <Text mr={8}>{lang.contact_lists.jobs.completed.temperature}:</Text>
          <Text fw={600}>{item.arguments.temperature}</Text>
        </Group>
      )}
      {item?.arguments?.datafieldId && (
        <Group gap={0} wrap="nowrap">
          <Text mr={8}>{lang.contact_lists.jobs.completed.field}:</Text>
          <Text fw={600}>
            {" "}
            {
              useConfigStore
                .getState()
                .datafields.find((x) => x.id === item?.arguments?.datafieldId)
                ?.name
            }{" "}
            #{item?.arguments?.datafieldId}
          </Text>
        </Group>
      )}
      {item?.arguments?.externalApiKeyId && (
        <Group>
          <Text>
            {lang.contact_lists.jobs.completed.openai_api_key}:
            <Anchor
              href={`/settings/integrations/main?highlight=${item?.arguments?.externalApiKeyId}`}
              target="_blank"
              fw={600}
              ml={8}
            >
              #{item?.arguments?.externalApiKeyId}
            </Anchor>
          </Text>
        </Group>
      )}
      {item?.arguments?.enrichExternalApi && (
        <Group>
          <Text>
            {lang.contact_lists.jobs.completed.api_key_type}:{" "}
            <span style={{ textTransform: "uppercase", fontWeight: 600 }}>
              {" "}
              {item.arguments.enrichExternalApi}{" "}
            </span>
          </Text>
        </Group>
      )}
      {item?.arguments?.blacklistId && (
        <Group>
          <Text>
            {lang.contact_lists.jobs.completed.blacklist}:{" "}
            <Anchor
              component={Link}
              to={"/blacklists/" + item?.arguments?.blacklistId}
              size="md"
              fw={600}
              mr={8}
            >
              #{item?.arguments?.blacklistId}
            </Anchor>
          </Text>
        </Group>
      )}
      {item?.arguments?.organizationId && (
        <Group>
          <Text>
            {lang.contact_lists.jobs.completed.org}:{" "}
            <Anchor
              component={Link}
              to={"/settings/organizations/" + item?.arguments?.organizationId}
              size="md"
              fw={600}
              mr={8}
            >
              #{item?.arguments?.organizationId}
            </Anchor>
          </Text>
        </Group>
      )}
      {item?.arguments?.enriched_contacts !== undefined && (
        <Group gap={0} wrap="nowrap" align="start">
          <Text mr={8}>
            {lang.contact_lists.jobs.completed.enriched_contacts}:
          </Text>
          <Text fw={600}>
            <NumberFormatter value={item?.arguments?.enriched_contacts} />
          </Text>
        </Group>
      )}
      {item?.contacts_extracted !== undefined &&
        item?.contacts_extracted !== null && (
          <Group gap={0} wrap="nowrap" align="start">
            <Text mr={8}>
              {lang.contact_lists.jobs.completed.contacts_extracted}:
            </Text>
            <Text fw={600}>
              <NumberFormatter value={item?.contacts_extracted} />
            </Text>
          </Group>
        )}
      {item?.arguments?.generateEmail !== undefined && (
        <Group gap={0} wrap="nowrap" align="start">
          <Text mr={8}>{lang.contact_lists.enrich.dialog.generate_email}:</Text>
          <Text fw={600}>
            {item?.arguments?.generateEmail ? lang.global.yes : lang.global.no}
          </Text>
        </Group>
      )}

      {item.type === "ContactListCopyContactListToPrm" && (
        <>
          <Text>
            {lang.contact_lists.jobs.completed.status}{" "}
            <b>
              {status_list()?.find((x) => x.value === item?.arguments?.status)
                .label || item?.arguments?.status}
            </b>
          </Text>
          {!isProgress && (
            <>
              <Text>
                <b style={{ marginRight: 4 }}>
                  <NumberFormatter
                    value={
                      item.import_contacts_response?.contacts_already_existing
                    }
                    thousandSeparator=" "
                  />
                </b>{" "}
                {lang.contact_lists.jobs.completed.contacts_already_existing}
              </Text>
            </>
          )}
        </>
      )}

      {isCompleted && (
        <ContactsResponse item={item} isCompleted={isCompleted} />
      )}

      {item.type === "GoogleExtractMapsSearch" && (
        <ArgumentsGoogle item={item} />
      )}
      {item.type === "DatabaseExtractContacts" && (
        <ArgumentsDatabase item={item} />
      )}
      {item.type.includes("Linkedin") && (
        <ArgumentsLinkedin item={item} isCompleted={isCompleted} />
      )}

      {item?.arguments?.programmationId &&
        item?.arguments?.workflowId &&
        item?.arguments?.stepId &&
        item?.arguments?.contactType && <ArgumentsCampaign item={item} />}

      <ArgumentsContactsSelection
        contactsSelection={item?.arguments?.contactsSelection}
      />
    </Stack>
  );
}
